<template>
  <div class="page-subtree-assist-operation">
    <div class="section-add">
      <div class="section-title">
        <div class="line"></div>
        <div class="txt">店铺信息</div>
        <channelTag :model="info.model" />
      </div>
      <div class="section-content defult-info">
        <div class="section-item">
          <div class="input">
            <div class="label">店铺简称</div>
            <div class="value">{{ info.simpleName }}</div>
          </div>
        </div>
        <div class="section-item">
          <div class="input">
            <div class="label">商户编号</div>
            <div class="value">{{ info.merchantNo }}</div>
          </div>
        </div>
        <div class="section-item">
          <div class="input">
            <div class="label">商户注册时间</div>
            <div class="value">{{ info.registryTime }}</div>
          </div>
        </div>
        <div class="section-item">
          <div class="input">
            <div class="label">法人姓名</div>
            <div class="value">{{ info.merName }}</div>
          </div>
        </div>
        <div class="section-item">
          <div class="input">
            <div class="label">机具编号</div>
            <div class="value">{{ $route.query.snCode || info.snCode }}</div>
          </div>
        </div>
      </div>

      <div class="section-title radius10">
        <div class="line"></div>
        <div class="txt">协助补充信息</div>
      </div>
      <div class="select-type">
        <div
          class="select-type-item"
          :class="info.merMode == 1 ? 'active' : ''"
          @click="changeTab(1)"
        >
          <img
            v-if="info.merMode == 1"
            src="@/assets/img/assist-operation/icon_individual_normal@2x.png"
          />
          <img
            v-else
            src="@/assets/img/assist-operation/icon_individual_disable@2x.png"
          />
          <div>个体户</div>
        </div>
        <!-- <div
          class="select-type-item"
          :class="info.merMode == 0 ? 'active' : ''"
          @click="changeTab(0)"
        >
          <img
            v-if="info.merMode == 0"
            src="@/assets/img/assist-operation/icon_firm_normal@2x.png"
          />
          <img
            v-else
            src="@/assets/img/assist-operation/icon_firm_disable@2x.png"
          />
          <div>企业</div>
        </div> -->
      </div>
      <!-- <div class="section-content">
        <div class="section-item">
          <div class="input">
            <div class="label">结算类型</div>
            <div class="section-js">
              <div class="section-js-item">
                <img src="@/assets/img/assist-operation/btn_agree@2x.png" />
                <label>对私法人</label>
              </div>
            </div>
          </div>
        </div>
      </div> -->

      <div class="section-title">
        <div class="line"></div>
        <div class="txt">上传营业执照</div>
      </div>
      <div class="section-license">
        <div class="section-license-inner">
          <div class="left">
            <div class="face">营业执照国徽面</div>
            <div class="txt">
              事业单位/民办非企业单位/基金会证件也点击此处上传
            </div>
          </div>
          <div class="right" @click="chooseImg('businessLicenseImg')">
            <img :src="info.businessLicenseImg || imgDefault" />
          </div>
        </div>
      </div>
      <div class="section-title">
        <div class="line"></div>
        <div class="txt">经营场所照片</div>
      </div>
      <div class="section-userinfo-wrap">
        <div class="section-userinfo">
          <div class="section-userinfo-item">
            <div class="img-wrap" @click="chooseImg('doorstepImg')">
              <img :src="info.doorstepImg || imgDefault" />
            </div>
            <div class="txt">门头照</div>
          </div>
          <div class="section-userinfo-item">
            <div class="img-wrap" @click="chooseImg('cashierImg')">
              <img :src="info.cashierImg || imgDefault" />
            </div>
            <div class="txt">收银台照</div>
          </div>
        </div>
        <div class="section-userinfo">
          <div class="section-userinfo-item">
            <div class="img-wrap" @click="chooseImg('premisesImg')">
              <img :src="info.premisesImg || imgDefault" />
            </div>
            <div class="txt">场所照</div>
          </div>
          <div class="section-userinfo-item">
            <div class="img-wrap" @click="chooseImg('houseNumberImg')">
              <img :src="info.houseNumberImg || imgDefault" />
            </div>
            <div class="txt">门牌号照</div>
          </div>
        </div>
      </div>

      <div class="section-content">
        <div class="section-item">
          <div class="input">
            <div class="label">法人姓名</div>
            <input
              v-model="info.legalPersonName"
              placeholder="请上传营业执照识别"
            />
          </div>
        </div>
        <div class="section-item">
          <div class="input">
            <div class="label">店铺名称</div>
            <input v-model="info.storeName" placeholder="请填写店铺名称" />
          </div>
        </div>
        <div class="section-item">
          <div class="input">
            <div class="label">营业执照名称</div>
            <input
              v-model="info.businessLicenseName"
              placeholder="请上传营业执照识别"
            />
          </div>
        </div>

        <div class="section-item">
          <div class="input">
            <div class="label">统一社会信用代码</div>
            <input
              v-model="info.unifiedSocialCreditCode"
              placeholder="请上传营业执照识别"
            />
          </div>
        </div>
        <div class="section-item">
          <div class="input">
            <div class="label">营业执照有效期</div>
            <div class="value">
              <input
                v-model="info.businessLicenseValidityStart"
                readonly
                placeholder="开始时间"
                @click="selectTime(1)"
              />
              至
              <input
                v-model="info.businessLicenseValidityEnd"
                readonly
                placeholder="结束时间"
                @click="selectTime(2)"
              />
            </div>
          </div>
        </div>
        <div class="section-item">
          <div class="input">
            <div class="label">所属省市区</div>
            <input
              v-model="selectedRegionStr"
              readonly
              placeholder="请选择省市区"
              @click="selectRegionClick"
            />
            <img class="icon-enter" src="~@/assets/img/icon-arrow-right.png" />
          </div>
        </div>
        <div class="section-item">
          <div class="input">
            <div class="label">装机地址</div>
            <input v-model="info.detailAddr" placeholder="请填写装机详细地址" />
          </div>
        </div>
        <div class="section-item">
          <div class="input">
            <div class="label">MCC行业类目</div>
            <input
              @click="showSelectMcc = true"
              readonly
              placeholder="请选择行业类目"
              :value="info.mccDesc || ''"
            />
            <img class="icon-enter" src="~@/assets/img/icon-arrow-right.png" />
          </div>
        </div>
      </div>
    </div>
    <div class="custom-button">
      <div class="btn" :class="{ active: isCanSubmit }" @click="onSubmit">
        确认提交
      </div>
    </div>
    <!-- 省市区弹窗 -->
    <select-region
      :show="showSelectRegion"
      @close="showSelectRegion = false"
      @confirm="getRegion"
    />
    <!-- mcc -->
    <select-mcc
      :show="showSelectMcc"
      :id="info.assistEntryId"
      :merMode="info.merMode"
      @close="showSelectMcc = false"
      @confirm="getMcc"
    />
    <!-- 营业执照有效期 -->
    <select-date
      :show="showSelectDate"
      @close="showSelectDate = false"
      @confirm="onConfirmSelectDate"
    />
  </div>
</template>
<script>
import { specCharPattern } from '@/utils'
import { filtion } from '@/utils/filtion'
import { chooseImage } from '@/common/oss'
import SelectRegion from '@/views/biz-components/assist-operation/select-region.vue'
import SelectMcc from '@/views/biz-components/assist-operation/select-mcc.vue'
import SelectDate from '@/views/biz-components/assist-operation/select-date.vue'
import channelTag from '@/views/components/channel-tag.vue'
import moment from 'moment'
import {
  storeAssistEntryBusinessLicenseOcr,
  storeAssistEntryGetAssistEntryDetail,
  commonGetLngAndLat,
  commonSelectAddr,
  storeAssistEntrySubmitEntry
} from '@/api/assist-operation'
export default {
  components: { SelectRegion, SelectMcc, SelectDate, channelTag },
  data() {
    return {
      imgDefault: require('@/assets/img/assist-operation/img_pic_big@2x.png'),
      showSelectRegion: false,
      showSelectMcc: false,
      selectedRegionStr: '',
      regionInfo: [], // 选中的省市区数组
      // 营业执照有效期
      startDate: '',
      endDate: '',
      changeEndDate: true,
      showSelectDate: false,
      selectDateType: 1, // 营业执照有效期时间选择类型  1开始、2结束
      info: {
        assistEntryId: this.$route.query.assistEntryId, //	协助进件商户记录id，列表返回
        snCode: this.$route.query.snCode,
        merMode: '1', //	商户类型 0企业 1个体 2小微
        settleType: '1', //	结算类型 1对私法人
        businessLicenseImg: '', //	营业执照图片
        doorstepImg: '', //	门头照图片
        cashierImg: '', //	收银台图片
        premisesImg: '', //	经营场所图片
        houseNumberImg: '', //	门牌号照片
        legalPersonName: '', //	法人姓名
        storeName: '', //	店铺名称
        businessLicenseName: '', //	营业执照名称
        unifiedSocialCreditCode: '', //	统一社会信用码
        businessLicenseValidityStart: '', //	营业执照有效期起期
        businessLicenseValidityEnd: '', //	营业执照有效期止期
        provinceCode: '', //	经营地址-省code
        provinceName: '', //	经营地址-省名称
        cityCode: '', //	经营地址-市code
        cityName: '', //	经营地址-市名称
        districtCode: '', //	经营地址-区code
        districtName: '', //	经营地址-区名称
        detailAddr: '', //	经营地址-详细地址
        mccCode: '', //	经营类型code
        mccDesc: '', //	经营类型描述
        cityName: '', //	经营地址-市名称
        longitude: '', //	定位经度
        latitude: '' //	定位纬度
      }
    }
  },
  watch: {
    'info.detailAddr'(newVal) {
      if (newVal) {
        this.info.detailAddr = newVal.replace(
          /[^\u4e00-\u9fa5a-zA-Z0-9\w]/g,
          ''
        )
      }
    }
  },
  computed: {
    isCanSubmit() {
      return (
        this.info.businessLicenseImg &&
        this.info.businessLicenseName &&
        this.info.unifiedSocialCreditCode &&
        this.info.businessLicenseValidityStart &&
        this.info.businessLicenseValidityEnd &&
        this.info.provinceCode &&
        this.info.detailAddr &&
        this.info.mccCode &&
        this.info.legalPersonName &&
        this.info.storeName &&
        this.info.premisesImg &&
        this.info.cashierImg &&
        this.info.doorstepImg &&
        this.info.houseNumberImg
      )
    }
  },
  created() {
    this.getAssistBusinessDetail()
  },
  mounted() {},
  methods: {
    getAssistBusinessDetail() {
      let params = {
        assistEntryId: this.$route.query.assistEntryId
      }
      console.log(params)
      storeAssistEntryGetAssistEntryDetail(params).then(res => {
        console.log(res)
        this.info = { ...this.info, ...res }
        if (this.info.businessLicenseImg) {
          // 识别营业执照信息
          this.getBusinessLicenseOCRResult(this.info.businessLicenseImg)
        }
      })
    },
    async onSubmit() {
      console.log('this.info', this.info)
      if (!this.info.businessLicenseImg) return this.$toast('请上传营业执照!')
      if (!this.info.doorstepImg) return this.$toast('请上传门头照!')
      if (!this.info.cashierImg) return this.$toast('请上传收银台照!')
      if (!this.info.premisesImg) return this.$toast('请上传场所照!')
      if (!this.info.houseNumberImg) return this.$toast('请上传门牌号照!')
      if (!this.info.legalPersonName) return this.$toast('法人姓名不能为空!')
      if (this.info.legalPersonName != this.info.merName)
        return this.$toast('法人姓名不正确!')
      if (!this.info.storeName) return this.$toast('店铺名称不能为空!')
      if (this.info.storeName.length > 20)
        return this.$toast('店铺名称不能超过20个字')
      if (/\d/.test(this.info.storeName)) {
        return this.$toast('店铺名称不可存在数字!')
      }
      if (filtion(this.info.storeName)) {
        return this.$toast('店铺名称不合法!')
      }
      if (specCharPattern(this.info.storeName)) {
        return this.$toast('店铺名称不允许带有特殊字符!')
      }
      if (!this.info.businessLicenseName)
        return this.$toast('营业执照名称不能为空!')
      if (!this.info.unifiedSocialCreditCode)
        return this.$toast('统一社会信用码不能为空!')
      if (
        !this.info.businessLicenseValidityStart ||
        !this.info.businessLicenseValidityEnd
      )
        return this.$toast('营业执照有效期不能为空!')
      if (!this.info.provinceCode) return this.$toast('请选择营业执照省市区!')

      // 营业执照地址校验
      if (!this.info.detailAddr) return this.$toast('装机地址不能为空!')
      if (this.info.detailAddr.length < 5 || this.info.detailAddr.length > 30) {
        this.$toast('请输入5-30个字的装机地址')
        return
      }
      if (specCharPattern(this.info.detailAddr)) {
        return this.$toast('装机地址不允许带有特殊字符!')
      }
      if (!this.info.longitude || !this.info.latitude) {
        // 手动输入反向获取经纬度
        if (
          this.info.detailAddr.includes('省') &&
          this.info.detailAddr.includes('市')
        ) {
          this.$toast('装机地址无需填写省市')
          return
        } else {
          let addr =
            this.info.provinceName + this.info.cityName + this.info.detailAddr
          await this.getLngAndLatByAddress(addr)
        }
      }
      if (!this.info.longitude || !this.info.latitude) {
        this.$dialog.alert({
          title: '提示',
          message: '获取经纬度失败，装机地址请填写营业执照详细地址'
        })
      }
      // 营业执照地址校验

      if (!this.info.mccCode) return this.$toast('请选择行业类目!')

      if (!this.isCanSubmit) {
        return
      }
      storeAssistEntrySubmitEntry({ ...this.info }).then(res => {
        console.log(res)
        this.$toast('操作成功!')
        setTimeout(() => {
          SyHybridSdk.closeWebView({
            params: {},
            success: res => {}
          })
        }, 1500)
      })
    },
    selectTime(type) {
      this.selectDateType = type
      // 1 营业执照有效日期 开始
      if (type == 2 && this.info.businessLicenseValidityEnd == '长期')
        return this.$toast('有效期为长期不可修改！')
      this.showSelectDate = true
    },
    onConfirmSelectDate(event) {
      this.showSelectDate = false
      if (this.selectDateType == 1) {
        let startTimeTemp = moment(event).valueOf()
        let endTimeTemp = moment(this.info.businessLicenseValidityEnd).valueOf()
        if (
          startTimeTemp > endTimeTemp &&
          this.info.businessLicenseValidityEnd !==
            moment(event).format('YYYYMMDD')
        ) {
          this.$toast('开始时间不能晚于结束时间')
        } else {
          this.info.businessLicenseValidityStart =
            moment(event).format('YYYYMMDD')
        }
      }
      if (this.selectDateType == 2) {
        let startTimeTemp = moment(
          this.info.businessLicenseValidityStart
        ).valueOf()
        let endTimeTemp = moment(event).valueOf()
        if (
          startTimeTemp > endTimeTemp &&
          this.info.businessLicenseValidityStart !==
            moment(event).format('YYYYMMDD')
        ) {
          this.$toast('结束时间不能早于开始时间')
        } else {
          this.info.businessLicenseValidityEnd =
            moment(event).format('YYYYMMDD')
        }
      }
    },
    getMcc(data) {
      this.showSelectMcc = false
      console.log(data)
      this.info.mccDesc = data.text
      this.info.mccCode = data.code
    },
    getRegion(regionInfo, selectedRegionStr) {
      // 获取选择的省市区信息
      this.regionInfo = regionInfo
      this.selectedRegionStr = selectedRegionStr
      this.info.provinceName = regionInfo[0].text
      this.info.provinceCode = regionInfo[0].code
      this.info.cityName = regionInfo[1].text
      this.info.cityCode = regionInfo[1].code
      this.info.districtName = regionInfo[2].text
      this.info.districtCode = regionInfo[2].code
    },
    selectRegionClick() {
      // 选择开户行所在省市
      this.showSelectRegion = true
    },
    changeTab(merMode) {
      if (merMode == this.info.merMode) {
        return
      }
      this.info.merMode = merMode
    },
    chooseImg(type) {
      chooseImage({
        count: 1,
        fileMaxSize: ''
      }).then(res => {
        if (type == 'businessLicenseImg') {
          this.info.businessLicenseImg = res[0] || ''
          // 识别营业执照信息
          this.getBusinessLicenseOCRResult(res[0])
        }
        if (type == 'premisesImg') {
          this.info.premisesImg = res[0]
        }
        if (type == 'cashierImg') {
          this.info.cashierImg = res[0]
        }
        if (type == 'doorstepImg') {
          this.info.doorstepImg = res[0]
        }
        if (type == 'houseNumberImg') {
          this.info.houseNumberImg = res[0]
        }
      })
    },
    getBusinessLicenseOCRResult(businessLicenseImg) {
      let params = {
        businessLicenseImg
      }
      storeAssistEntryBusinessLicenseOcr(params).then(res => {
        console.log(res)
        if (res) {
          this.info.unifiedSocialCreditCode = res.socialCreditCode || ''
          this.info.storeName = res.companyName || ''
          this.info.businessLicenseName = res.companyName || ''
          this.info.legalPersonName = res.juridicalPerson || ''
          let startDate = '',
            endDate = ''
          startDate = res.establishDate.replace(/[^\d+]/g, '')
          // startDate = res.establishDate
          if (
            res.expireDate == '永久' ||
            res.expireDate == '长期' ||
            res.expireDate == '无'
          ) {
            endDate = res.expireDate == '无' ? '长期' : res.expireDate
            this.changeEndDate = false
          } else {
            endDate = res.expireDate.replace(/[^\d+]/g, '')
            this.changeEndDate = true
          }
          this.info.businessLicenseValidityStart = startDate
          this.info.businessLicenseValidityEnd = endDate
          this.info.detailAddr = res.companyAddr
          // 根据详细地址获取经纬度  这里可以获取营业执照地址
          this.getLngAndLatByAddress()
        }
      })
    },
    async getLngAndLatByAddress(addr) {
      let address = this.info.detailAddr
      if (addr) {
        address = addr
      }
      let res = await commonGetLngAndLat({
        address
      })
      console.log(res)
      if (res) {
        this.info.longitude = res.longitude
        this.info.latitude = res.latitude
        // 根据经度维度查询具体的省市区
        if (this.info.longitude && this.info.latitude && !addr) {
          this.getLocationInfo()
        }
      } else {
        if (addr) {
          this.$toast('装机地址请填写营业执照详细地址')
        } else {
          this.$toast('经纬度获取失败')
        }
      }
    },
    getLocationInfo() {
      // 企业根据详细地址查经纬度
      let params = {
        latitude: this.info.latitude || '',
        longitude: this.info.longitude || '',
        type: 3 //	固定传3
      }
      commonSelectAddr(params).then(resFetch => {
        console.log(resFetch)
        if (resFetch) {
          let result = {
            ...params,
            ...resFetch
          }
          this.info.latitude = result.latitude
          this.info.longitude = result.longitude
          this.info.provinceCode = result.provinceCode
          this.info.provinceName = result.province
          this.info.cityCode = result.cityCode
          this.info.cityName = result.city
          this.info.districtCode = result.districtCode
            ? result.districtCode
            : result.cityCode
          this.info.districtName = result.district || ''
          this.info.detailAddr = result.formattedAddress
          this.selectedRegionStr =
            this.info.provinceName + this.info.cityName + this.info.districtName
        }
      })
    }
  }
}
</script>
